import React, { PropTypes } from "react"

import ClassList from "./class-list"
import { fetchClassList } from "./actions"

const Grades = ({ children }) => (
  <div className="row">
    <div className="col-sm-3">
      <ClassList />
    </div>
    <div className="col-sm-9">{children}</div>
  </div>
)

Grades.propTypes = {
  children: PropTypes.node,
}

Grades.onEnter = store => () => store.dispatch(fetchClassList())
//Grades.onEnter = store => () => false

export default Grades



// WEBPACK FOOTER //
// ./src/containers/Grades/index.js